import { Box, Card, Grid, Modal, Stack, Typography } from '@mui/material';
import CancelIcon from '../../../icons/close.svg';
import ConfirmationTick from '../../../icons/ConfirmationTick.svg';
import { LoadingButton } from '@mui/lab';
import SpinnerWithNoConfirmation from '../../../shared/Modal/spinnerWithNoConfirmation';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { deleteSenderIdentity, selectPropertyGroupDetailsState } from '../../../shared/sagas/propertyGroups/propertyGroupsSlice';

export interface ConfirmSenderIdentityDeleteModalProps {
  open: boolean;
  onClose: () => void;
  senderIdentityId?: string;
  propertyGroupUuid: string;
}

export const ConfirmSenderIdentityDeleteModal = (props: ConfirmSenderIdentityDeleteModalProps) => {
  const { isDeletingSenderIdentity, isDeletingSenderIdentitySuccess, isDeletingSenderIdentityFailed } = useSelector(selectPropertyGroupDetailsState);
  const dispatch = useDispatch();
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '16px',
    height: '523px',
    pointerEvents: 'auto',
    width: '472px',
    maxWidth: '472px',
    borderRadius: '24px',
    outline: 'none',
  };

  const onHandleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const onHandleDeleteConfirm = () => {
    if (props.senderIdentityId) {
      dispatch(
        deleteSenderIdentity({
          propertyGroupUuid: props.propertyGroupUuid,
          senderIdentityUuid: props.senderIdentityId,
        }),
      );
    }
  };

  useEffect(() => {
    if (isDeletingSenderIdentitySuccess || isDeletingSenderIdentityFailed) {
      onHandleClose();
    }
  }, [isDeletingSenderIdentitySuccess, isDeletingSenderIdentityFailed]);

  return (
    <Modal
      open={props.open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      BackdropProps={{
        invisible: false,
      }}
      disableEscapeKeyDown
      disableAutoFocus={true}
    >
      <Card sx={style}>
        <Grid container display="flex" justifyContent="center">
          <Grid item xs={12} display="flex" justifyContent="center">
            <Typography
              sx={{
                fontFamily: 'Work Sans !important',
                fontStyle: 'normal',
                fontWeight: '600',
                fontSize: '18px !important',
                lineHeight: '21px !important',
                color: '#14142B',
              }}
            >
              Confirm Delete
            </Typography>
          </Grid>

          <Grid container mt={4} rowSpacing={2} sx={{ width: '90%', height: '100%' }}>
            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
              {isDeletingSenderIdentity ? (
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    height: '200px',
                  }}
                >
                  <SpinnerWithNoConfirmation />
                </Stack>
              ) : (
                <img src={ConfirmationTick} alt="close" style={{ cursor: 'pointer', height: '200px' }} />
              )}

              <Typography sx={{ marginTop: '20px' }}>Deleting this sender identity cannot be undone.</Typography>
              <Typography sx={{ marginTop: '20px' }}>Are you sure you want to proceed?</Typography>
            </Grid>
          </Grid>

          <Box sx={{ position: 'absolute', bottom: 15, width: '94%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <LoadingButton
                variant="contained"
                loading={isDeletingSenderIdentity}
                disabled={isDeletingSenderIdentity}
                style={{
                  textTransform: 'none',
                  fontFamily: "'Open Sans', sans-serif",
                  fontStyle: 'normal',
                  fontWeight: 700,
                  backgroundColor: '#39A2DB',
                  borderRadius: '24px',
                }}
                onClick={onHandleDeleteConfirm}
              >
                Yes
              </LoadingButton>
              <LoadingButton
                variant="contained"
                style={{
                  textTransform: 'none',
                  fontFamily: "'Open Sans', sans-serif",
                  fontStyle: 'normal',
                  fontWeight: 700,
                  backgroundColor: '#39A2DB',
                  borderRadius: '24px',
                  marginLeft: '15px',
                }}
                onClick={onHandleClose}
              >
                No
              </LoadingButton>
            </Box>
          </Box>

          {/* Close Icon */}
          <Grid item sx={{ position: 'absolute', top: 18, right: 20 }}>
            <img src={CancelIcon} alt="close" style={{ cursor: 'pointer' }} onClick={onHandleClose} />
          </Grid>
        </Grid>
      </Card>
    </Modal>
  );
};
